import { IPurchasableVariant } from "@smartrr/shared/entities/PurchasableVariant";
import { ISmartrrBundlePacks } from "@smartrr/shared/entities/SellingPlanGroup";
import { shopifyGidToNumber } from "@smartrr/shared/utils/ensureShopifyGid";
import { MappedPurchasableVariant } from "@smartrr/shared/utils/useVariantToPurchasableMap";

import { smartrrAccountConfig } from "@customer-app/account/config";
import { useSmartrrCustomerSelector } from "@customer-app/state/typedCustomerReduxHooks";

export function filterVariantsBySearchText(
  variantsToBeFiltered: IPurchasableVariant[],
  subscribedPurchasablesSearchText: string,
  validVariantsFromSubscribablePurchasables: IPurchasableVariant[],
  variantToPurchasableMap: MappedPurchasableVariant
) {
  if (subscribedPurchasablesSearchText) {
    const text = subscribedPurchasablesSearchText.toLowerCase();
    return validVariantsFromSubscribablePurchasables.filter(vnt => {
      const purchasable = variantToPurchasableMap[vnt.id];
      if (vnt.purchasableVariantName) {
        return (
          vnt.purchasableVariantName.toLowerCase().includes(text) ||
          purchasable.purchasableName.toLowerCase().includes(text)
        );
      }
    });
  }
  return variantsToBeFiltered;
}

export function filterVariantsByHiddenProducts(
  variantsToBeFiltered: IPurchasableVariant[],
  variantToPurchasableMap: MappedPurchasableVariant
) {
  const hiddenProducts = smartrrAccountConfig.hiddenProducts;
  if (hiddenProducts?.length) {
    return variantsToBeFiltered.filter(vnt => {
      const purchasable = variantToPurchasableMap[vnt.id];
      const shopifyId = purchasable.shopifyId ? shopifyGidToNumber(purchasable.shopifyId).toString() : "";
      return !hiddenProducts.includes(shopifyId);
    });
  }
  return variantsToBeFiltered;
}

export function useFilteredVariantsByCollectionContents(
  activePack: ISmartrrBundlePacks | undefined,
  variantsToBeFiltered: IPurchasableVariant[],
  variantToPurchasableMap: MappedPurchasableVariant
) {
  const collections = useSmartrrCustomerSelector(state => state.bundles.bundleCollections);
  if (activePack?.collectionString) {
    const selectedCollection = collections.find(coll => {
      return coll?.handle && coll.handle === activePack?.collectionString;
    });

    if (selectedCollection?.products?.edges) {
      variantsToBeFiltered = variantsToBeFiltered.filter(vnt => {
        const purchasable = variantToPurchasableMap[vnt.id];
        return selectedCollection.products.edges.some(collectionProduct => {
          if (collectionProduct?.node?.id && purchasable?.shopifyId) {
            return collectionProduct.node.id === purchasable.shopifyId;
          }
          return false;
        });
      });
    }
  }
  return variantsToBeFiltered;
}
